import { SparklesIcon } from '@heroicons/react/24/outline';
import { ButtonHTMLAttributes } from 'react';

type EnrichIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
};

export function EnrichIconButton({ label = 'Enriquecer', className = '', ...props }: EnrichIconButtonProps) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-orange-600 transition-colors hover:bg-orange-50 hover:text-orange-700 disabled:opacity-50 ${className}`}
      {...props}
    >
      <SparklesIcon className="h-5 w-5" />
    </button>
  );
}
